import React from "react";
import Link from "next/link";

import { Button } from "@/components/ui/button";

const FinalCTA = ({
  finalCTAHeading,
  partnerName,
  finalCTAButtonText,
  ctaLink,
}: {
  finalCTAHeading: string;
  partnerName: string;
  finalCTAButtonText: string;
  ctaLink: string;
}) => {
  return (
    <div className="bg-rebolt-100 text-black px-5 md:px-16 py-16">
      <div className="flex flex-col justify-between gap-6 max-w-7xl w-full mx-auto relative">
        <div className="flex flex-col gap-5 md:gap-2">
          <h1 className="font-clash font-semibold text-4xl md:text-5xl leading-[1.2] tracking-tight">
            {finalCTAHeading || "Ready to grow your business with Rebolt?"}
          </h1>
          <p className="text-base md:text-lg text-black line-height-[1.5]">
            {`Join ${partnerName} members already building high-performing websites that rank, convert, and grow — without the upfront cost.`}
          </p>
        </div>

        <Link href={ctaLink} target="_blank" rel="noreferrer noopener" className="w-full md:w-fit">
          <Button variant="rebolt-primary" className="h-fit py-3! px-6! w-full md:w-fit">
            {finalCTAButtonText || "Get started"}
          </Button>
        </Link>
      </div>
    </div>
  );
};

export default FinalCTA;
